<template>
	<widget-card
		colClasses="xs12"
		:heading="widget.text.caption[$i18n.locale]" custom-card-classes="chart-wrapper">
		<div class="d-flex" v-if="widget.data.isSeasonCompare && widget.data.isSeasonCompare === true">
			<v-select
				:items="days"
				v-model="day"
				box
				label="Day" class="ma-1"></v-select>
			<v-select
				:items="months"
				v-model="month"
				item-text="name"
				value="value"
				box
				label="Month" class="ma-1"></v-select>
		</div>

		<bar-chart class="chart-wrapper" :sets="series" :is-money-value="isMoneyValue" :styles="myStyles"></bar-chart>
	</widget-card>
</template>

<script>
	import Enumerable from 'linq'
	import BarChart from './BarChart.js'
	import { mapGetters } from 'vuex'
	import moment from 'moment'

	export default {
		props: {
			widget: {
				type: Object,
				required: true
			}
		},
		components: {
			BarChart
		},
		computed: {
			...mapGetters([
				'season',
				'reportingData',
				'lastSeasonReportingData'
			]),
			myStyles () {
				if (this.widget.data.isSeasonCompare && this.widget.data.isSeasonCompare === true) {
					return {
						height: `80%`,
						position: 'relative'
					}
				} else {
					return {
						height: `95%`,
						position: 'relative'
					}
				}
			},
			series: function () {
				if (this.reportingData.length > 0) {
					if (this.widget.data.sumField) {
						const series = []
						let enumerable = Enumerable.from(this.reportingData)
						
						if (this.widget.data.partners && this.widget.data.partners.length > 0) {
							enumerable = enumerable.where(item =>  this.widget.data.partners.includes(item['wo_partner_name']))
						}

						if (this.widget.data.isSeasonCompare && this.widget.data.isSeasonCompare === true) {
							let enumerableLastSeason = Enumerable.from(this.lastSeasonReportingData)
							const thisYearTargetDate = new Date(moment().year(), this.month - 1, this.day)
							enumerable = enumerable
								.where(x => x.wo_date <= thisYearTargetDate)
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
									enumerable = enumerable
							.orderBy('$.fromDate')
							.toArray()

							series.push({
								name: 'This season',
								data: enumerable
							})

							const lastYearTargetDate = new Date(moment().year() - 1, this.month - 1, this.day)
							enumerableLastSeason = enumerableLastSeason
								.where(x => x.wo_date <= lastYearTargetDate)
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
								.orderBy('$.fromDate')
								.toArray()

							series.push({
								name: 'Last season',
								data: enumerableLastSeason,
								type: 'line'
							})

							return series
						}
						if (this.widget.data.isSplittingContractual && this.widget.data.isSplittingContractual === true) {
							let contractual = enumerable
								.where(item => item['is_contractual'] == true)
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
								.orderBy('$.fromDate')
								.toArray()

							let nonContractual = enumerable
								.where(item => item['is_contractual'] == false)
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
								.orderBy('$.fromDate')
								.toArray()


							const missingContractual = []
							const missingNonContractual = []

							contractual.map(item => {
								if (!nonContractual.find(i => i.label === item.label)) {
									const newItem = Object.assign({}, item)
									newItem.value = 0
									missingNonContractual.push(newItem)
								}
							})

							nonContractual.map(item => {
								if (!contractual.find(i => i.label === item.label)) {
									const newItem = Object.assign({}, item)
									newItem.value = 0
									missingContractual.push(newItem)
								}
							})

							const dateSorter = (a, b) => {
								a = new Date(a.fromDate);
								b = new Date(b.fromDate);
								return a > b ? 1 : a < b ? -1 : 0;
							}

							contractual = contractual.concat(missingContractual).sort(dateSorter)
							nonContractual = nonContractual.concat(missingNonContractual).sort(dateSorter)

							series.push({
								name: 'Contractual',
								data: contractual,
							})
							series.push({
								name: 'Non contractual',
								data: nonContractual
							})
							return series

						} else {
							enumerable = enumerable
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
									enumerable = enumerable
							.orderBy('$.fromDate')
							.toArray()

							series.push({
								name: '',
								data: enumerable
							})
							return series
						}
					
					}
					return []
				} else {
					return[]
				}


			},
			isMoneyValue: function () {
				return this.widget.data.sumField ? this.widget.data.sumField.isMoneyValue : false
			},
			days () {
				return [...Array(moment().daysInMonth())].map((_, i) => i + 1)
			},
			months () {
				return moment.months().map((m, i) => ({
					name: m,
					value: i + 1
				}))
				
			},
		},
		watch: {
			'widget.layout.h': {
				handler (val) {
					// this.$refs.chart.render()
				}
			}
		},
		data() {
			return {
				day: moment().date(),
				month: moment().month() + 1
			}
		},
		methods: {
			
		}
	};
</script>

<style>
.chart-wrapper {
  position: relative;
  height: 95%;
  width: 100%;
}
</style>
